import { toastr } from "react-redux-toastr";
import {
  client,
  apiFormatter,
  handleErrors,
  stringifyQuery,
} from "utils/api";

export const toggleFilters = () => (dispatch) => {
  dispatch({ type: "REMARKS_TOGGLE_FILTERS" });
};

export const filterRemarks = (query) => async (dispatch) => {
  dispatch({
    type: "REMARKS_SET_FILTERS_QUERY",
    query,
  });
};

export const getRemarks = ({
  page = 1,
  per_page = 10,
  ...rest
}) => (dispatch, getState) => {
  const {
    status,
    filters: { query },
  } = getState().remarks;
  status === "invalid"
    ? dispatch({ type: "REMARKS_LOADING" })
    : dispatch({ type: "REMARKS_SEARCHING" });
  client
    .get(
      `/remarks?${stringifyQuery({
        ...rest,
        page,
        per_page,
        include: "reporter,reported_user",
        ...query,
      })}`
    )
    .then(({ data }) => {
      dispatch({
        type: "REMARKS_SUCCESS",
        data: apiFormatter(data),
        meta: data.meta,
      });
    })
    .catch(() => {
      dispatch({ type: "REMARKS_FAILURE" });
      toastr.error(
        "Błąd",
        "Wystąpił błąd podczas pobierania uwag"
      );
    });
};

export const getRemark = (id) => async (dispatch) => {
  dispatch({ type: "REMARK_LOADING" });
  await client
    .get(`/remarks/${id}?include=reporter,reported_user`)
    .then(({ data }) => {
      dispatch({
        type: "REMARK_SUCCESS",
        data: apiFormatter(data),
      });
    })
    .catch(() => {
      dispatch({ type: "REMARK_FAILURE" });
      toastr.error(
        "Błąd",
        "Wystąpił błąd podczas pobierania uwagi"
      );
    });
};

export const createRemark = (values) => {
  return new Promise(async (resolve, reject) => {
    await client
      .post(`/remarks`, values)
      .then(({ data }) => {
        resolve(data?.data?.id);
        toastr.success("Sukces", "Uwaga została utworzona");
      })
      .catch((err) => {
        toastr.error(
          "Błąd",
          "Wystąpił błąd podczas tworzenia uwagi"
        );
        reject(handleErrors(err.response.data.errors));
      });
  });
};

export const updateRemark = (id, values) => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    await client
      .put(`/remarks/${id}?include=reporter,reported_user`, values)
      .then(({ data }) => {
        toastr.success(
          "Sukces",
          "Uwaga została zaktualizowana"
        );
        dispatch({
          type: "REMARK_SUCCESS",
          data: apiFormatter(data),
        });
        resolve();
      })
      .catch((err) => {
        toastr.error(
          "Błąd",
          "Wystąpił błąd podczas aktualizowania uwagi"
        );
        reject(handleErrors(err.response.data.errors));
      });
  });
};

export const deleteRemark = (id) =>
  new Promise(async (resolve, reject) => {
    try {
      await client.delete(`/remarks/${id}`);
      toastr.success("Sukces", "Uwaga została usunięta");
      resolve();
    } catch (error) {
      toastr.error(
        "Błąd",
        "Wystąpił błąd podczas usuwania uwagi"
      );
      reject(handleErrors(error.response.data.errors));
    }
  });

export const resetRemarkEdit = () => async (dispatch) => {
  dispatch({ type: "REMARK_RESET" });
};
